export default __webpack_public_path__ + "static/media/influencer_profile01.767e87de.svg";